<template>
  <input
    type="button"
    :value="schema.buttonText"
    @click="click"
    :disabled="disabled">
</template>

<script>
  import { abstractField } from 'vue-form-generator';

  export default {
    mixins: [abstractField],

    methods: {

      click() {
        if (this.schema.onClick) {
          this.schema.onClick(this.model, this.schema, this.formOptions.context, this.$parent.vfg);
        }
      },
    },
  };
</script>
